import React, { useState, useEffect, useRef } from 'react';
import { FaCalendarAlt, FaProjectDiagram, FaSmile, FaUserTie, FaGlobe} from 'react-icons/fa';
import Home from "../components/homePage/Home/Home";
import Divisions from "../components/homePage/Divisions/Divisions";
import Footer from "../components/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import SEOHead from "../components/SEO/SEOHead";
import HomePageNavBar from '../components/NavigationBar/NavigationBar';
import MissionStatement from '../components/homePage/Mission,Vision&CoreValues/Mission';
import Vision from '../components/homePage/Mission,Vision&CoreValues/Vision';
import CoreValues from '../components/homePage/Mission,Vision&CoreValues/CoreValues';
import CallToAction from '../components/homePage/CTA/HomeCtA';





// Animated Statistics Component
function AnimatedStatistics() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const statistics = [
    {
      icon: FaCalendarAlt,
      value: 1,
      suffix: '+',
      label: 'Years Experience',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: FaProjectDiagram,
      value: 6,
      suffix: '+',
      label: 'Projects Completed',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      icon: FaSmile,
      value: 6,
      suffix: '+',
      label: 'Happy Clients',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: FaUserTie,
      value: 10,
      suffix: '+',
      label: 'Team Members',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      icon: FaGlobe,
      value: 1,
      suffix: '+',
      label: 'Country Served',
      color: 'from-blue-500 to-indigo-500'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const CountUp = ({ end, suffix, duration = 2000 }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!isVisible) return;

      setCount(0);
      let startTime;
      let animationId;

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / duration, 1);
        setCount(Math.floor(progress * end));

        if (progress < 1) {
          animationId = requestAnimationFrame(animate);
        }
      };

      animationId = requestAnimationFrame(animate);

      return () => {
        if (animationId) {
          cancelAnimationFrame(animationId);
        }
      };
      // e
    }, [end, duration, isVisible]);  // eslint-disable-line

    return <span>{count}{suffix}</span>;
  };

  return (
    <section ref={sectionRef} className='py-20 bg-gradient-to-r from-green-700 via-emerald-700 to-teal-700 relative overflow-hidden'>
      {/* Background Pattern */}
      <div className='absolute inset-0'>
        <div className='absolute inset-0'>
          <svg className='w-full h-full opacity-10' viewBox='0 0 100 100'>
            <defs>
              <pattern id='statsPattern' x='0' y='0' width='20' height='20' patternUnits='userSpaceOnUse'>
                <rect x='8' y='8' width='4' height='4' fill='currentColor' className='text-white'/>
                <circle cx='5' cy='15' r='1' fill='currentColor' className='text-white'/>
              </pattern>
            </defs>
            <rect width='100%' height='100%' fill='url(#statsPattern)'/>
          </svg>
        </div>
      </div>

      <div className='container mx-auto px-6 relative z-10'>
        <div className='text-center mb-16'>
          <h2 className='text-4xl md:text-5xl font-bold text-white mb-6 font-comfortaa'>
            Our <span className='text-yellow-300'>Achievements</span>
          </h2>
          <p className='text-xl text-green-100 max-w-3xl mx-auto'>
            Numbers that reflect our commitment to excellence and continuous growth in serving our clients.
          </p>
        </div>

        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 max-w-6xl mx-auto'>
          {statistics.map((stat, index) => (
            <div key={index} className='text-center group'>
              <div className={`w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-r ${stat.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <stat.icon className='text-white text-2xl' />
              </div>
              <div className='text-4xl md:text-5xl font-bold text-white mb-2 font-comfortaa'>
                <CountUp end={stat.value} suffix={stat.suffix} />
              </div>
              <p className='text-green-100 font-medium'>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



export default function HomePage() {
  return (
    <div className='overflow-hidden'>
      <SEOHead 
        title="Arieri's World Limited - Leading Technology Solutions Provider in Kenya"
        description="Transform your business with expert web development, cloud computing, data analytics & mobile app development services in Kenya. Innovation meets excellence."
        keywords="web development Kenya, cloud computing services, data analytics Kenya, mobile app development, digital transformation, technology solutions Nairobi"
        url="https://arierisworld.com"
      />
      {/* Add semantic HTML structure for SEO */}
      <header>
        <HomePageNavBar />
      </header>
      
      <main>
        <section id="home" aria-label="Hero Section">
          <Home />
        </section>
        
        <section id="mission" aria-label="About Us - Mission, Vision and Values">
          <MissionStatement />
          <Vision />
          <CoreValues />
          <AnimatedStatistics />
        </section>
        
        <section id="divisions" aria-label="Areas of specialization">
          <Divisions />
        </section>
        
        {/* <SuccessStoriesCarousel /> */}     
        
        <section id="contact" aria-label="Contact Call to Action">
          <CallToAction />
        </section>
      </main>
      
      <Footer />
      <ScrollToTop />
    </div>
  )
}
